export default "/kiban/_next/static/images/02_4L_1-2-1_withoutBH-3a2eb4da7c88bb323ecca63a381e2e9d.png";